var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 137,
    viewBox: "0 0 162 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.821 119.833V88.6168H103.906V119.833H135.821ZM109.054 93.7662V114.685H130.671V93.7662H109.054Z",
    fill: "#255056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.176 45.3097H103.676V50.4591H135.176V45.3097Z",
    fill: "#255056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.176 35.6604H103.676V40.8081H135.176V35.6604Z",
    fill: "#255056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.176 25.3987H103.676V30.5464H135.176V25.3987Z",
    fill: "#255056"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2882 25.402H25.7878V30.5497H57.2882V25.402Z",
    fill: "#255056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7878 35.6637H57.2882V40.8114H25.7878V35.6637Z",
    fill: "#255056"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7878 45.313H57.2882V50.4624H25.7878V45.313Z",
    fill: "#255056"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.924153 0.757812L0.924072 136.994H161.357V0.757812H0.924153ZM83.9119 131.847V76.3781H156.208V131.847H83.9119ZM156.208 71.2304H83.9119V5.90549H156.208V71.2304ZM6.29665 5.90549H78.3695L78.3694 71.2304H6.29665V5.90549ZM6.29665 76.3781H78.3694L78.3694 131.847H57.731V91.8778H26.2306V131.847H6.29665V76.3781ZM31.3783 97.0272V131.847H52.5815V97.0272H31.3783Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixed);
export default __webpack_public_path__ + "static/media/mixed.583fffd6d5f87091df316c01fc71cfdb.svg";
export { ForwardRef as ReactComponent };